var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { graphql, isNetworkRequestInFlight, PageError, Result, } from "core/utils";
import { processResult } from "./processResult";
import { query } from "./QUERY";
/**
 * @NOTE This function depends on hooks
 * @TODO extract route matching out of this function as this function does
 * too much. If route matching is handled elsewhere then the dependency
 * on the routes is also removed.
 */
export var prepGetData = function (routes) { return function (appState, slug) {
    var _a = graphql.useQueryWithResult(query, {
        variables: { url: slug },
        fetchPolicy: "cache-and-network",
    }), networkStatus = _a.networkStatus, result = _a.result, refetch = _a.refetch;
    var processed = processResult(appState, slug, result, refetch);
    if (!Result.isSuccess(processed))
        return processed;
    var data = getDataFromProcessed(processed);
    if (data === null) {
        return noDataResult(slug);
    }
    if (data.slug !== slug)
        return redirectResult(data.slug);
    var matchedRoute = routes.find(function (route) { return route.match(data.type, data); });
    if (typeof matchedRoute === "undefined") {
        return noMatchResult(data.type, slug);
    }
    return Result.success({
        kind: "Matched",
        page: __assign(__assign({}, data), { fetchingData: isNetworkRequestInFlight(networkStatus) }),
        route: matchedRoute,
    });
}; };
function noDataResult(slug) {
    return Result.fail(PageError.notFoundError("Received query data was null.", slug));
}
function redirectResult(redirectUrl) {
    return Result.success({ kind: "Redirected", redirectUrl: redirectUrl });
}
function noMatchResult(pageType, slug) {
    return Result.fail(PageError.notFoundError("No matched route for page type ".concat(pageType), slug));
}
function getDataFromProcessed(processed) {
    return processed.value.getEntityBySlug;
}
